<div [formGroup]="form" class="flex flex-column gap-2 buttonset-container">
  <label [attr.for]="item.key" class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>

  <span [ngClass]="{ 'p-buttonset': true, 'pointer-events-none': disabled }">
    <button
      *ngFor="let option of item.options"
      pButton
      pRipple
      [label]="option.label | translate"
      [icon]="isSelected(option) ? 'pi pi-check' : ''"
      [ngClass]="{
        'p-button-outlined': !isSelected(option) || disabled,
        selected: isSelected(option),
        'p-button-danger': isInValid,
        'p-button-greyed-out': disabled
      }"
      (click)="
        controlItem.setValue(option.value);
        controlItem.markAsTouched();
        controlItem.markAsDirty()
      "
      type="button"
    ></button>
  </span>

  <small
    class="p-error block font-italic"
    *ngIf="isInValid && hasError('required')"
  >
    {{
      item.errorMessage?.required?.message || 'YOU_CANNOT_LEAVE_IT_BLANK'
        | translate : item.errorMessage?.required?.params
    }}
  </small>
</div>
